<template>
  <v-container
    d-flex
    align-content-center
    fill-height
    fluid
    style="height: 100vh"
    class="pt-0"
  >
    <v-row justify="center">
      <v-col cols="12" sm="12" md="auto" class="pa-4" style="max-width: 100%">
        <alert-edit
          :alert-source="alertSource"
          :alert-metric="alertMetric"
          :alert-url="alertUrl"
          @confirm="$emit('close')"
          @cancel="$emit('close')"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import AlertEdit from './Overlay/AlertEdit.vue';

export default {
  components: {
    AlertEdit,
  },
  props: {
    alertSource: {
      type: String,
      default: '',
    },
    alertMetric: {
      type: String,
      default: '',
    },
    alertUrl: {
      type: String,
      default: '',
    },
  },
  computed: {},
};
</script>

<style></style>
